const settings = ['social', 'marketing', 'clienteling', 'loyalty'] as const

const storeNames = [
  '6 Box Test',
  'Agape Christian Marketplace',
  'Alamo Botanicals',
  'Bahama Mama',
  'Blazed Bakery',
  'Blazin Bad',
  'Blu Spot',
  'Cabin Creations',
  'Cedar Chest',
  'clientelier',
  'Cloud Nine Pajamas',
  'Dab City Tobacco & Vape',
  "Dolly's Gaming Cafe",
  'fabric bash',
  'faherty brand',
  'guys and co',
  'Hippie Hut',
  'House of Vape',
  'Jack of Smoke',
  'ladder',
  'Lucky Joes',
  'morley',
  'Nephos Vape Shop',
  'Olive You Boutique',
  'oneshop',
  'oneshop-dev',
  'OneShop Vend Test',
  'penelope t',
  'periwinkle',
  'q clothier',
  'Raby Hardware & Outdoors',
  'Scout & Mollys Plano',
  'Scout & Mollys (Annapolis, Mosaic, & Reston Stores)',
  "sharla's boutique",
  'skirt',
  'Slots By The Fox',
  'Snooty Fox',
  'Supplement Hut',
  'Tobacco Island',
  'TWB Home Decor',
  'tristan',
  'unode50',
  'Whilden',
  'whimzy',
] as const

const unoFrenchStores = ['Carrefour Laval'] as const
const unoSpanishStores = [
  'Plaza Carolina',
  'Plaza Del Caribe',
  'Plaza Del Sol',
  'Plaza Las Americas',
  'Puerto Rico Pop Up Plaza',
  'Pop Up Plaza Del Caribe',
] as const

export { settings, storeNames, unoFrenchStores, unoSpanishStores }
